import _createForOfIteratorHelper from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
export var visitEachAudioNodeOnce = function visitEachAudioNodeOnce(cycles, visitor) {
  var counts = new Map();
  var _iterator = _createForOfIteratorHelper(cycles),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var cycle = _step.value;
      var _iterator2 = _createForOfIteratorHelper(cycle),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var audioNode = _step2.value;
          var count = counts.get(audioNode);
          counts.set(audioNode, count === undefined ? 1 : count + 1);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  counts.forEach(function (count, audioNode) {
    return visitor(audioNode, count);
  });
};